import React from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  sectionMargins,
  visuallyHidden,
} from '../styles';
import { Container } from './ui';
import ProductCategoryCard from './ProductCategoryCard';

const StyledProductCategoryListing = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled.h2`
  ${visuallyHidden()};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.tsmall`
    grid-template-columns: repeat(6, 1fr);
  `}

  ${minBreakpointQuery.small`
    gap: 30px;
  `}

  ${minBreakpointQuery.smedium`
    grid-auto-rows: 380px;
    row-gap: 40px;
  `}

  ${minBreakpointQuery.large`
    grid-auto-rows: 410px;
    row-gap: 50px;
  `}

  ${minBreakpointQuery.xlarge`
    row-gap: 60px;
  `}
`;

const StyledItem = styled(ProductCategoryCard)`
  ${maxBreakpointQuery.smedium`
    height: 50vw;
  `}

  ${minBreakpointQuery.tsmall`
    grid-column: span 3;
  `}

  ${({ itemsAmount }) => {
    if (itemsAmount === 3 || itemsAmount > 4) {
      return css`
        &:nth-child(-n + 3) {
          ${minBreakpointQuery.medium`
            grid-column: span 2;
          `}
        }
      `;
    }
  }}

  ${({ itemsAmount }) => {
    if (itemsAmount > 5 && itemsAmount % 2 === 0) {
      return css`
        &:nth-last-child(-n + 3) {
          ${minBreakpointQuery.medium`
            grid-column: span 2;
          `}
        }
      `;
    }
  }}
`;

const ProductCategoryListing = ({ heading, items }) => (
  <StyledProductCategoryListing>
    <StyledHeading>{heading}</StyledHeading>
    <Container>
      <StyledItems>
        {items.map(item => (
          <StyledItem
            key={item.id}
            image={item.featuredImage}
            heading={item.title}
            page={item}
            itemsAmount={items.length}
          />
        ))}
      </StyledItems>
    </Container>
  </StyledProductCategoryListing>
);

export default ProductCategoryListing;
